import {useState} from 'react'
import {
    ModalHistoria,
    ModalKlonujProjekt,
    ModalDodajOsobePowiazana,
    ModalUsunProjekt,
    ModalWycofajProjekt,
    ModalProsbaOdblokujHarmonogram,
    ModalOdblokujHarmonogram,
    ModalHistoriaPlanHarm,
    ModalHistoriaSprawozdanie,
    ModalProsbaAnulujProjekt,
    ModalAnulujProjekt,
    ModalArchiwizujProjekt,
    ModalProsbaOdblokujKp,
    ModalOdblokujKp,
    ModalProsbaOdblokujSprawozdanie,
    ModalOdblokujSprawozdanie,
    ModalProsbaWznowieniaKp,
    ModalWznowieniaKp,
    ModalPrzepnijProjekt,
    ModalProsbaTymczasoweOdblokujSprawozdanie,
    ModalTymczasoweOdblokujSprawozdanie,
    ModalCofnijTymczasoweOdblokowanieSprawozdanie,
} from '../components/modals.jsx'
import {LinkContainer} from 'react-router-bootstrap'
import {Dropdown} from 'react-bootstrap'
import ButtonWithIcon from '../../../../common/ButtonWithIcon.jsx'
import {Icons} from '../../../../common/Icons.jsx'
import {ActionsDropdown} from '../../../../common/ActionsDropdown.jsx'
import {SimpleTable} from '../../../../common/simpleTable/SimpleTable.jsx'
import {createTableLista} from '../columns/tableListaProjektow.jsx'
import PropTypes from 'prop-types'
import {fetchListaSprawozdan} from '../../../../../api/domain/sprawozdania/queries/useListaSprawozdan.jsx'
import {fetchListaElementow} from '../../../../../api/domain/elementyRejstru/queries/useListaElementow.jsx'
import {useOkienkoSprawozdania} from '../../../../../api/domain/sprawozdania/queries/useOkienkoSprawozdania.jsx'
import {MAIN_REJESTR_API_LONG} from '../../../../utils/consts.js'
import {useSelector, useDispatch} from 'react-redux'
import {setSilent} from '../../../../../redux/meta.js'
import {handleDownloadPdf} from '../../../../utils/handlers/index.js'

export const ListaElementyRejestru = ({
                                          listaPozycji,
                                          detailKey,
                                          setQuery,
                                          queryBuilder,
                                          loading,
                                          exportFileName,
                                          filterType,
                                      }) => {
    const statusy = useSelector((state) => state.statusy)
    const [currPozycja, setCurrPozycja] = useState({})
    const [modalState, setModalState] = useState({
        delete: false,
        wycofaj: false,
        // wycofajHarm: false,
        historiaProjektu: false,
        historiaPlanHarm: false,
        powiaz: false,
        openModal: false,
        ocen: false,
        klonuj: false,
        harm: false,
        harmProsbaOdblokuj: false,
        harmOdblokuj: false,
        kpProsbaOdblokuj: false,
        kpOdblokuj: false,
        procesHarm: false,
        procesProj: false,
        sprawozdanieView: false,
        sprawozdanieEdit: false,
        procesSprawozdanie: false,
        historiaSprawozdanie: false,
        gantt: false,
        prosbaAnuluj: false,
        anuluj: false,
        archiwizuj: false,
        przepnijProjekt: false,
        sprawozdanieProsbaOdblokuj: false,
        sprawozdanieOdblokuj: false,
        kpProsbaWznowienie: false,
        kpWznowienie: false,
        sprawozdanieProsbaTymczasoweOdblokuj: false,
        sprawozdanieTymczasoweOdblokuj: false,
        sprawozdanieCofnijTymczasoweOdblokuj: false,
    })
    const rola = useSelector((state) => state.user.role)
    const permissions = useSelector((state) => state.user.permissions)
    const hasOwnerPermission = Array.isArray(permissions)
        ? permissions.includes('owner')
        : Boolean(permissions?.owner);
    const isWpOwner = rola === 'wp' && hasOwnerPermission
    const isOper = rola === 'oper'
    const userTypeForPdf = rola === 'oper' ? 'oper' : ''
    const canModifyRejestr = Array.isArray(permissions) && permissions.includes('rejestr_modyfikacja')
    const canViewProcess = Array.isArray(permissions) && permissions.includes('rejestr_obsluga_podglad')
    const canModifyProcess = Array.isArray(permissions) && permissions.includes('rejestr_obsluga_modyfikacja')
    const dispatch = useDispatch()
    const {data: okienkoData} = useOkienkoSprawozdania()

    const [sprawozdaniaState, setSprawozdaniaState] = useState({
        loading: null,
        data: {}
    })

    const [kpWersjeState, setKpWersjeState] = useState({
        loading: null,
        data: {}
    })

    const buildKpWersje = (row) => {
        const maxWersja = Math.max(Number(row?.wersja) || 1, 1)
        const wersje = Array.from({length: maxWersja}, (_, idx) => {
            const wersja = maxWersja - idx
            return {
                rejestr_id: row.id,
                wersja,
                status: wersja === maxWersja ? row.projekt_status : null,
            }
        })

        if (row?.projekt_status === 'W_EDYCJI') {
            return wersje.filter((item) => item.wersja !== maxWersja)
        }

        return wersje
    }

    const handleFetchKpWersje = async (rejestrId) => {
        if (kpWersjeState.data[rejestrId]) return

        setKpWersjeState(prev => ({...prev, loading: rejestrId}))
        dispatch(setSilent(true))
        try {
            const lista = await fetchListaElementow(rola)
            const row = lista.find((item) => Number(item.id) === Number(rejestrId))
            const wersje = row ? buildKpWersje(row) : []
            setKpWersjeState(prev => ({
                loading: null,
                data: {...prev.data, [rejestrId]: wersje}
            }))
        } catch (error) {
            setKpWersjeState(prev => ({...prev, loading: null}))
        }
    }

    const handleFetchSprawozdania = async (rejestrId) => {
        if (sprawozdaniaState.data[rejestrId]) return

        setSprawozdaniaState(prev => ({...prev, loading: rejestrId}))
        dispatch(setSilent(true))
        try {
            const list = await fetchListaSprawozdan(rejestrId, rola)
            const sorted = [...(list || [])].sort((a, b) => (b?.id ?? 0) - (a?.id ?? 0))
            const latest = sorted[0] || null
            const zakonczone = sorted.filter((item) => ['ZAKOŃCZONY'].includes(item?.status))
            const latestIsZlozonyOrPrzyjety = ['ZŁOŻONY', 'PRZYJĘTY'].includes(latest?.status)

            const selected = latestIsZlozonyOrPrzyjety
                ? [latest, ...zakonczone.slice(0, 2)]
                : zakonczone.slice(0, 3)

            const uniqueSelected = selected.filter((item, index, arr) => item && arr.findIndex((x) => x.id === item.id) === index)
            setSprawozdaniaState(prev => ({
                loading: null,
                data: {...prev.data, [rejestrId]: uniqueSelected}
            }))
        } catch (error) {
            setSprawozdaniaState(prev => ({...prev, loading: null}))
        }
    }

    const renderSprawozdanieItem = (spr, idx) => (
        <Dropdown.Item
            key={`spr-${spr.id}-${idx}`}
            title={`Pobierz PDF sprawozdania ${spr.numer}`}
            onClick={() => handleDownloadPdf(
                spr.id,
                'pdf',
                userTypeForPdf,
                spr.wersja ?? 1,
                'sprawozdanie'
            )}
        >
            <Icons.download className="me-2" />
            {spr.numer} - {spr.status}
        </Dropdown.Item>
    )

    const renderKpWersjaItem = (kp, idx) => (
        <Dropdown.Item
            key={`kp-${kp.wersja}-${idx}`}
            title={`Pobierz PDF karty projektu - wersja ${kp.wersja}`}
            onClick={() => handleDownloadPdf(
                kp.rejestr_id,
                'pdf',
                userTypeForPdf,
                kp.wersja,
                'rejestr'
            )}
        >
            <Icons.download className="me-2" />
            Wersja {kp.wersja}{kp.status ? ` - ${kp.status}` : ''}
        </Dropdown.Item>
    )

    const openModal = (type, data) => {
        setCurrPozycja(data)
        setModalState((prev) => ({...prev, [type]: true}))
    }

    const closeModal = (type) =>
        setModalState((prev) => ({...prev, [type]: false}))

    const handleAction = (row, type) => {
        openModal(type, row)
    }

    const modals = () => (
        <>
            <ModalWycofajProjekt
                show={modalState.wycofaj}
                handleClose={() => closeModal('wycofaj')}
                currPozycja={currPozycja}
                disabled={loading}
            />

            <ModalUsunProjekt
                show={modalState.delete}
                handleClose={() => closeModal('delete')}
                currPozycja={currPozycja}
                disabled={loading}
            />

            <ModalHistoria
                show={modalState.historiaProjektu}
                handleClose={() => closeModal('historiaProjektu')}
                currPozycja={currPozycja}
                disabled={loading}
            />

            <ModalHistoriaPlanHarm
                show={modalState.historiaPlanHarm}
                handleClose={() => closeModal('historiaPlanHarm')}
                currPozycja={currPozycja}
                disabled={loading}
            />

            <ModalHistoriaSprawozdanie
                show={modalState.historiaSprawozdanie}
                handleClose={() => closeModal('historiaSprawozdanie')}
                currPozycja={currPozycja}
                disabled={loading}
            />

            <ModalKlonujProjekt
                show={modalState.klonuj}
                handleClose={() => closeModal('klonuj')}
                currPozycja={currPozycja}
                disabled={loading}
            />

            <ModalDodajOsobePowiazana
                show={modalState.powiaz}
                handleClose={() => closeModal('powiaz')}
                currPozycja={currPozycja}
                disabled={loading}
            />
            <ModalProsbaOdblokujHarmonogram
                show={modalState.harmProsbaOdblokuj}
                handleClose={() => closeModal('harmProsbaOdblokuj')}
                currPozycja={currPozycja}
                disabled={loading}
            />
            <ModalOdblokujHarmonogram
                show={modalState.harmOdblokuj}
                handleClose={() => closeModal('harmOdblokuj')}
                currPozycja={currPozycja}
                disabled={loading}
            />
            <ModalProsbaAnulujProjekt
                show={modalState.prosbaAnuluj}
                handleClose={() => closeModal('prosbaAnuluj')}
                currPozycja={currPozycja}
                disabled={loading}
            />
            <ModalAnulujProjekt
                show={modalState.anuluj}
                handleClose={() => closeModal('anuluj')}
                currPozycja={currPozycja}
                disabled={loading}
            />
            <ModalProsbaOdblokujKp
                show={modalState.kpProsbaOdblokuj}
                handleClose={() => closeModal('kpProsbaOdblokuj')}
                currPozycja={currPozycja}
                disabled={loading}
            />
            <ModalOdblokujKp
                show={modalState.kpOdblokuj}
                handleClose={() => closeModal('kpOdblokuj')}
                currPozycja={currPozycja}
                disabled={loading}
            />
            <ModalArchiwizujProjekt
                show={modalState.archiwizuj}
                handleClose={() => closeModal('archiwizuj')}
                currPozycja={currPozycja}
            />
            <ModalPrzepnijProjekt
                show={modalState.przepnijProjekt}
                handleClose={() => closeModal('przepnijProjekt')}
                currPozycja={currPozycja}
            />
            <ModalProsbaOdblokujSprawozdanie
                show={modalState.sprawozdanieProsbaOdblokuj}
                handleClose={() => closeModal('sprawozdanieProsbaOdblokuj')}
                currPozycja={currPozycja}
            />
            <ModalOdblokujSprawozdanie
                show={modalState.sprawozdanieOdblokuj}
                handleClose={() => closeModal('sprawozdanieOdblokuj')}
                currPozycja={currPozycja}
            />
            <ModalProsbaWznowieniaKp
                show={modalState.kpProsbaWznowienie}
                handleClose={() => closeModal('kpProsbaWznowienie')}
                currPozycja={currPozycja}
                disabled={loading}
            />
            <ModalWznowieniaKp
                show={modalState.kpWznowienie}
                handleClose={() => closeModal('kpWznowienie')}
                currPozycja={currPozycja}
                disabled={loading}
            />
            <ModalProsbaTymczasoweOdblokujSprawozdanie
                show={modalState.sprawozdanieProsbaTymczasoweOdblokuj}
                handleClose={() => closeModal('sprawozdanieProsbaTymczasoweOdblokuj')}
                rejestrId={currPozycja.id}
                tytul={currPozycja.tytul}
            />
            <ModalTymczasoweOdblokujSprawozdanie
                show={modalState.sprawozdanieTymczasoweOdblokuj}
                handleClose={() => closeModal('sprawozdanieTymczasoweOdblokuj')}
                rejestrId={currPozycja.id}
                tytul={currPozycja.tytul}
                uzasadnienieProsba={currPozycja.uzasadnienie_prosba_tymczasowe_odblokowanie_spr}
                kwartal={currPozycja.tymczasowe_odblokowanie_spr_kwartal}
                rok={currPozycja.tymczasowe_odblokowanie_spr_rok}
            />
            <ModalCofnijTymczasoweOdblokowanieSprawozdanie
                show={modalState.sprawozdanieCofnijTymczasoweOdblokuj}
                handleClose={() => closeModal('sprawozdanieCofnijTymczasoweOdblokuj')}
                rejestrId={currPozycja.id}
                tytul={currPozycja.tytul}
            />
        </>
    )

    const th = () => {
        return (
            <>
                <th>Akcje karty projektu</th>
                <th>Akcje plan. harm.</th>
                <th>Akcje sprawozdania</th>
            </>
        )
    }

    const td = (row) => {
        // TODO: obsługa ze względu na role i uprawnienia
        const isCategoryA = row.kategoria === 'A'
        const isCategoryB = row.kategoria === 'B'
        const canAccessSprawozdanie = isCategoryA || isCategoryB
        const isAnulowana = row.projekt_status === 'ANULOWANA'
        const isArchiwalna = row.projekt_status === 'ARCHIWALNA'
        const hasProsbaAnulowanie = row.czy_prosba_anulowania === 'Tak'
        const hasProsbaWznowienia = row.projekt_czy_prosba_wznowienia === 'Tak'
        const isArchiveView = filterType === 'archiwum'

        const wOkienku = okienkoData?.w_okienku ?? false
        const hasTymczasoweOdblokowanie = row.czy_tymczasowe_odblokowanie_spr === 'Tak'
        const efektywneOkienku = wOkienku || hasTymczasoweOdblokowanie

        const sprawozdanieDotyczyAktualnegoKwartalu = efektywneOkienku
            && (wOkienku
                ? (Number(row.sprawozdanie_rok) === okienkoData?.aktualny_rok
                    && Number(row.sprawozdanie_kwartal) === okienkoData?.aktualny_kwartal)
                : (Number(row.sprawozdanie_rok) === Number(row.tymczasowe_odblokowanie_spr_rok)
                    && Number(row.sprawozdanie_kwartal) === Number(row.tymczasowe_odblokowanie_spr_kwartal))
            )

        const canEditSprawozdanieA = isCategoryA && row.sprawozdanie_id &&
            (row.projekt_status === 'ZAKOŃCZONA') &&
            (row.plan_harm_status === 'PRZYJĘTY') &&
            (row.sprawozdanie_status === 'W_EDYCJI' || row.sprawozdanie_status === 'DO_POPRAWY') &&
            sprawozdanieDotyczyAktualnegoKwartalu

        const canEditSprawozdanieB = isCategoryB && row.sprawozdanie_id &&
            (row.projekt_status === 'ZAKOŃCZONA') &&
            (row.sprawozdanie_status === 'W_EDYCJI' || row.sprawozdanie_status === 'DO_POPRAWY') &&
            sprawozdanieDotyczyAktualnegoKwartalu

        const allowItem = {
            show: {
                view: true,
                edit: !isArchiveView && (rola === 'oper' ? false : true) && (row.projekt_status === 'W_EDYCJI' || row.projekt_status === 'DO_POPRAWY') && !isAnulowana,
                delete: !isArchiveView && (rola === 'oper' ? false : true) && (row.projekt_status === 'W_EDYCJI') && row.wersja == 1 && !isAnulowana,
                wycofaj: !isArchiveView && (isWpOwner) && (row.projekt_status === 'ZŁOŻONY') && !isAnulowana,
                wycofajHarm: !isArchiveView && !isAnulowana,
                gantt: isCategoryA,
                dodaj: !isArchiveView && !isAnulowana,
                realizuje: true,
                zakoncz: false,
                decyzje: false,
                historiaProjektu: true,
                historiaPlanHarm: isCategoryA,
                historiaSprawozdanie: canAccessSprawozdanie,
                klonuj: !isArchiveView && isWpOwner && !isAnulowana,
                powiaz: (isWpOwner && !isAnulowana && !isArchiveView) || rola === 'oper',
                harm: !isArchiveView && (rola === 'oper' ? false : true) && (row.plan_harm_status === 'W_EDYCJI') && isCategoryA && !isAnulowana,
                harmView: isCategoryA,
                harmProsbaOdblokuj: !isArchiveView && (rola === 'oper' ? false : row.plan_harm_id) && row.plan_harm_status !== 'W_EDYCJI' && isCategoryA && !isAnulowana && !isArchiwalna && row.plan_harm_czy_prosba_odblokowanie !== "Tak",
                harmOdblokuj: !isArchiveView && canModifyRejestr && (rola === 'wp' ? false : row.plan_harm_id) && (row.plan_harm_status === 'ZŁOŻONY' || row.plan_harm_status === 'PRZYJĘTY' || row.plan_harm_status === 'DO_POPRAWY') && isCategoryA && !isAnulowana,
                kpProsbaOdblokuj: !isArchiveView && (rola === 'oper' ? false : true) && (row.projekt_status === 'ZŁOŻONA' || row.projekt_status === 'PRZYJĘTA' || row.projekt_status === 'ZAKOŃCZONA') && !isAnulowana && !isArchiwalna && row.projekt_czy_prosba_odblokowanie !== "Tak",
                kpOdblokuj: !isArchiveView && canModifyRejestr && (rola === 'wp' ? false : true) && (row.projekt_status === 'ZŁOŻONA' || row.projekt_status === 'PRZYJĘTA' || row.projekt_status === 'ZAKOŃCZONA' || row.projekt_status === 'DO_POPRAWY') && !isAnulowana,
                procesHarm: canViewProcess && (rola === 'wp' ? false : row.plan_harm_id) && isCategoryA,
                procProj: canViewProcess && (rola === 'wp' ? false : true),
                sprawozdanieView: canAccessSprawozdanie,
                sprawozdanieEdit: !isArchiveView && (rola === 'oper' ? false : true) && (canEditSprawozdanieA || canEditSprawozdanieB) && !isAnulowana,
                listaSprawozdan: canAccessSprawozdanie,
                prosbaAnuluj: isWpOwner && !isAnulowana && !isArchiwalna && !hasProsbaAnulowanie && (row.projekt_status !== 'W_EDYCJI' || row.wersja > 1),
                anuluj: canModifyProcess && rola === 'oper' && !isAnulowana,
                archiwizuj: canModifyProcess && rola === 'oper' && !isArchiwalna,
                przepnijProjekt: canModifyRejestr && rola === 'oper',
                sprawozdanieProsbaOdblokuj: (rola === 'oper' ? false : true) && !!row.sprawozdanie_id && !isAnulowana && !isArchiwalna && ['ZŁOŻONY', 'PRZYJĘTY', 'ZAKOŃCZONY'].includes(row.sprawozdanie_status) && row.sprawozdanie_czy_prosba_odblokowanie !== 'Tak',
                sprawozdanieOdblokuj: canModifyProcess && rola === 'oper' && !!row.sprawozdanie_id && ['ZŁOŻONY', 'PRZYJĘTY', 'ZAKOŃCZONY'].includes(row.sprawozdanie_status) && efektywneOkienku,
                kpProsbaWznowienie: isWpOwner && isAnulowana && !hasProsbaWznowienia,
                kpWznowienie: canModifyProcess && rola === 'oper' && isAnulowana,
                sprawozdanieProsbaTymczasoweOdblokuj: false,
                sprawozdanieTymczasoweOdblokuj: canModifyProcess && rola === 'oper' && canAccessSprawozdanie && !isAnulowana && row.czy_tymczasowe_odblokowanie_spr !== 'Tak',
                sprawozdanieCofnijTymczasoweOdblokuj: canModifyProcess && rola === 'oper' && canAccessSprawozdanie && row.czy_tymczasowe_odblokowanie_spr === 'Tak',
            },
            disabled: {
                prosbaAnuluj: hasProsbaAnulowanie,
            }
        }
        const projektActions = [
            {
                show: allowItem.show.historiaProjektu,
                onClick: () => handleAction(row, 'historiaProjektu'),
                icon: <Icons.history />,
                label: 'Historia karty projektu',
            },
            {
                show: allowItem.show.powiaz,
                to: `/${rola}/rejestr/${row.id}/profile`,
                icon: <Icons.addUser />,
                label: 'Powiązani operatorzy',
            },
            {
                show: allowItem.show.klonuj,
                onClick: () => handleAction(row, 'klonuj'),
                icon: <Icons.copy />,
                label: 'Sklonuj kartę',
            },
            {
                show: allowItem.show.wycofaj,
                onClick: () => handleAction(row, 'wycofaj'),
                icon: <Icons.wycofaj />,
                label: 'Wycofaj projekt',
                variant: 'warning',
            },
            {
                show: allowItem.show.kpProsbaOdblokuj,
                onClick: () => handleAction(row, 'kpProsbaOdblokuj'),
                icon: <Icons.unlock />,
                label: 'Prośba o odblokowanie karty',
                variant: 'warning',
            },
            {
                show: allowItem.show.kpOdblokuj,
                onClick: () => handleAction(row, 'kpOdblokuj'),
                icon: <Icons.unlock />,
                label: 'Odblokuj kartę projektu',
                variant: 'warning',
            },
            {
                show: allowItem.show.delete,
                onClick: () => handleAction(row, 'delete'),
                icon: <Icons.delete />,
                label: 'Usuń projekt',
                variant: 'danger',
            },
            {
                show: allowItem.show.prosbaAnuluj,
                onClick: () => handleAction(row, 'prosbaAnuluj'),
                disabled: allowItem.disabled.prosbaAnuluj,
                icon: <Icons.cancel />,
                label: 'Prośba o anulowanie projektu',
                variant: 'danger',
            },
            {
                show: allowItem.show.anuluj,
                onClick: () => handleAction(row, 'anuluj'),
                icon: <Icons.cancel />,
                label: 'Anuluj projekt',
                variant: 'danger',
            },
            {
                show: allowItem.show.archiwizuj,
                onClick: () => handleAction(row, 'archiwizuj'),
                icon: <Icons.archive />,
                label: 'Archiwizuj projekt',
                variant: 'dark',
            },
            {
                show: allowItem.show.przepnijProjekt,
                onClick: () => handleAction(row, 'przepnijProjekt'),
                icon: <Icons.reassign />,
                label: 'Przepnij projekt',
            },
            {
                show: allowItem.show.kpProsbaWznowienie,
                onClick: () => handleAction(row, 'kpProsbaWznowienie'),
                icon: <Icons.update />,
                label: 'Prośba o wznowienie projektu',
                variant: 'success',
            },
            {
                show: allowItem.show.kpWznowienie,
                onClick: () => handleAction(row, 'kpWznowienie'),
                icon: <Icons.update />,
                label: 'Wznów projekt',
                variant: 'success',
            },
        ]

        const planHarmActions = [
            {
                show: allowItem.show.historiaPlanHarm,
                onClick: () => handleAction(row, 'historiaPlanHarm'),
                icon: <Icons.history />,
                label: 'Historia harmonogramu',
            },
            {
                show: allowItem.show.gantt,
                to: `/${rola}/harm/gantt/${row.id}`,
                icon: <Icons.charts />,
                label: 'Wykres Gantta',
            },
            {
                show: allowItem.show.harmProsbaOdblokuj,
                onClick: () => handleAction(row, 'harmProsbaOdblokuj'),
                icon: <Icons.unlock />,
                label: 'Prośba o odblokowanie harm.',
                variant: 'warning',
            },
            {
                show: allowItem.show.harmOdblokuj,
                onClick: () => handleAction(row, 'harmOdblokuj'),
                icon: <Icons.unlock />,
                label: 'Odblokuj harmonogram',
                variant: 'warning',
            },
        ]

        const sprawozdaniaActions = [
            {
                show: allowItem.show.listaSprawozdan,
                to: `/${rola}/sprawozdanie/lista/${row.id}`,
                icon: <Icons.details />,
                label: 'Lista sprawozdań',
            },
            {
                show: allowItem.show.sprawozdanieProsbaOdblokuj,
                onClick: () => handleAction(row, 'sprawozdanieProsbaOdblokuj'),
                icon: <Icons.unlock />,
                label: 'Prośba o odblokowanie spr.',
                variant: 'warning',
            },
            {
                show: allowItem.show.sprawozdanieOdblokuj,
                onClick: () => handleAction(row, 'sprawozdanieOdblokuj'),
                icon: <Icons.unlock />,
                label: 'Odblokuj sprawozdanie',
                variant: 'warning',
            },
            {
                show: allowItem.show.sprawozdanieProsbaTymczasoweOdblokuj,
                onClick: () => handleAction(row, 'sprawozdanieProsbaTymczasoweOdblokuj'),
                icon: <Icons.unlock />,
                label: 'Prośba o tymcz. odblok. spr.',
                variant: 'warning',
            },
            {
                show: allowItem.show.sprawozdanieTymczasoweOdblokuj,
                onClick: () => handleAction(row, 'sprawozdanieTymczasoweOdblokuj'),
                icon: <Icons.unlock />,
                label: row.czy_prosba_tymczasowe_odblokowanie_spr === 'Tak'
                    ? 'Obsłuż prośbę o tymcz. odblok. sprawozdawczości'
                    : 'Tymczasowe odblokowanie sprawozdawczości',
                variant: 'danger',
            },
            {
                show: allowItem.show.sprawozdanieCofnijTymczasoweOdblokuj,
                onClick: () => handleAction(row, 'sprawozdanieCofnijTymczasoweOdblokuj'),
                icon: <Icons.lock />,
                label: 'Cofnij tymcz. odblok. sprawozdawczości',
                variant: 'danger',
            },
        ]

        return (
            <>
                <td className={'pe-4'}>
                    <div className="d-flex align-items-center gap-1">
                        <LinkContainer
                            to={`/${rola}/rejestr/karta/podglad/${row.id}`}
                        >
                            <ButtonWithIcon
                                variant={'secondary'}
                                onClick={() => handleAction(row, 'view')}
                                size={'sm'}
                                icon={<Icons.eye/>}
                                title='Podgląd projektu'
                            />
                        </LinkContainer>
                        {allowItem.show.edit && (
                            <LinkContainer
                                to={`/${rola}/rejestr/karta/edycja/${row.id}`}
                            >
                                <ButtonWithIcon
                                    onClick={() => handleAction(row, 'edit')}
                                    disabled={loading}
                                    size={'sm'}
                                    icon={<Icons.edit/>}
                                    title='Edytuj kartę projektu'
                                />
                            </LinkContainer>
                        )}
                        {allowItem.show.procProj && (
                            <LinkContainer to={`/${rola}/${MAIN_REJESTR_API_LONG}/proces/lista/${row.id}`}>
                                <ButtonWithIcon
                                    size={'sm'}
                                    icon={<Icons.proces />}
                                    title='Proces projektu'
                                />
                            </LinkContainer>
                        )}
                        <ActionsDropdown
                            actions={projektActions}
                            dynamicState={kpWersjeState}
                            onFetch={handleFetchKpWersje}
                            itemId={row.id}
                            renderDynamicItem={renderKpWersjaItem}
                            dynamicHeader="Wersje karty projektu"
                            loadingText="Pobieranie wersji karty projektu..."
                            emptyDynamicText="Brak wersji karty projektu"
                            icon={<Icons.project />}
                            title="Więcej akcji projektu"
                        />
                    </div>
                </td>
                {/*Akcje harmonogramu*/}
                <td>
                    <div className="d-flex align-items-center gap-1">
                        {allowItem.show.harmView && (
                            <LinkContainer to={`/${rola}/harm/podglad/${row.id}`}>
                                <ButtonWithIcon
                                    variant={'secondary'}
                                    size={'sm'}
                                    icon={<Icons.eye />}
                                    title='Podgląd harmonogramu'
                                />
                            </LinkContainer>
                        )}
                        {allowItem.show.harm && (
                            <LinkContainer to={`/${rola}/harm/edycja/${row.id}`}>
                                <ButtonWithIcon
                                    size={'sm'}
                                    icon={<Icons.edit />}
                                    title='Edycja harmonogramu'
                                />
                            </LinkContainer>
                        )}
                        {allowItem.show.procesHarm && (
                            <LinkContainer to={`/${rola}/harm/proces/lista/${row.id}`}>
                                <ButtonWithIcon
                                    size={'sm'}
                                    icon={<Icons.proces />}
                                    title='Proces harmonogramu'
                                />
                            </LinkContainer>
                        )}
                        <ActionsDropdown
                            show={isCategoryA}
                            actions={planHarmActions}
                            icon={<Icons.calendar />}
                            title="Więcej akcji plan. harm."
                        />
                    </div>
                </td>
                {/*Akcje sprawozdania*/}
                <td>
                    <div className="d-flex align-items-center gap-1">
                        {allowItem.show.sprawozdanieView && row.sprawozdanie_id && (
                            <LinkContainer to={`/${rola}/sprawozdanie/podglad/${row.id}/${row.sprawozdanie_id}`}>
                                <ButtonWithIcon
                                    variant={'secondary'}
                                    size={'sm'}
                                    icon={<Icons.eye />}
                                    title='Podgląd najnowszego sprawozdania'
                                />
                            </LinkContainer>
                        )}
                        {allowItem.show.sprawozdanieEdit && (
                            <LinkContainer to={`/${rola}/sprawozdanie/edycja/${row.id}/${row.sprawozdanie_id}`}>
                                <ButtonWithIcon
                                    size={'sm'}
                                    icon={<Icons.edit />}
                                    title='Edycja sprawozdania'
                                />
                            </LinkContainer>
                        )}
                        <ActionsDropdown
                            show={canAccessSprawozdanie}
                            actions={sprawozdaniaActions}
                            dynamicState={sprawozdaniaState}
                            onFetch={handleFetchSprawozdania}
                            itemId={row.id}
                            renderDynamicItem={renderSprawozdanieItem}
                            dynamicHeader="Wersje sprawozdań (maks. 3 ostatnie)"
                            loadingText="Pobieranie wersji sprawozdań..."
                            emptyDynamicText="Brak sprawozdań"
                            icon={<Icons.report />}
                            title="Więcej akcji sprawozdania"
                        />
                    </div>
                </td>
            </>
        )
    }
    const baseFilter = createTableLista({
        statusy,
    }).filter((i) => i.wszystkie !== 0 && (isOper || i.accessorKey !== 'podmiot'))

    return (
        <>
            {Object.keys(modalState || {}).some((k) => k) && modals()}

            <div className={'d-flex justify-content-end gap-3'}>
                <>
                    {isWpOwner && (
                        <LinkContainer
                            to={`/${rola}/${MAIN_REJESTR_API_LONG}/inicjuj`}
                        >
                            <ButtonWithIcon
                                text={'Dodaj nową kartę projektu'}
                                variant={'secondary'}
                                icon={<Icons.add/>}
                                size={'lg'}
                                title='Dodaj nową kartę projektu'
                            />
                        </LinkContainer>
                    )}
                </>
            </div>
            <SimpleTable
                exportFileName={exportFileName}
                queryBuilder={queryBuilder}
                setQuery={setQuery}
                detailKey={detailKey}
                columns={baseFilter}
                addTh={th}
                addTd={td}
                data={Array.isArray(listaPozycji?.data) ? listaPozycji.data : (listaPozycji?.data?.list || [])}
            />
        </>
    )
}

ListaElementyRejestru.propTypes = {
    aktywne: PropTypes.bool,
    listaPozycji: PropTypes.object,
    detailKey: PropTypes.string,
    setQuery: PropTypes.func,
    queryBuilder: PropTypes.func,
    loading: PropTypes.bool,
    exportFileName: PropTypes.string,
    filterType: PropTypes.oneOf(['aktywne', 'prosby', 'archiwum']),
}
